import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlService } from './url.service';
import { PessoaAcompanhamentoConsultaDto } from '../dtos/acompanhamentos/pessoa-acompanhamento-consulta-dto';
import { Observable } from 'rxjs';
import { PessoaAcompanhamentoHistoricoDto } from '../dtos/acompanhamentos/pessoa-acompanhamento-historico-dto';
import { PessoaAcompanhamentoInsercaoDto } from '../dtos/acompanhamentos/pessoa-acompanhamento-insercao-dto';
import { PessoaAcompanhamentoReativacaoDto } from '../dtos/acompanhamentos/pessoa-acompanhamento-reativacao-dto';
import { PessoaAcompanhamentoInativacaoDto } from '../dtos/acompanhamentos/pessoa-acompanhamento-inativacao-dto';
import { DelPessoaAcompanhamentoAtualizacaoDto, PessoaAcompanhamentoAtualizacaoDto } from '../dtos/acompanhamentos/pessoa-acompanhamento-atualizacao-dto';
import { ListarAcompanhamentosDoProfissionalEntrada } from '../dtos/acompanhamentos/listar-acompanhamentos-do-profissional-entrada';
import { ListarAcompanhamentosDaPessoaEntrada } from '../dtos/acompanhamentos/listar-acompanhamentos-da-pessoa-entrada';
import { LPessoaAcompanhamentoEventoDto } from '../dtos/acompanhamentos/l-pessoa-acompanhamento-evento-dto';
import { AcompanhamentoCidOperacaoDto } from '../dtos/acompanhamentos/acompanhamento-cid-operacao-dto';
import { PessoaAcompanhamentoResumoInteracaoDiaDto } from '../dtos/acompanhamentos/pessoa-acompanhamento-resumo-interacao-dia-dto';
import { ConsultarInteracaoDiaDto } from '../dtos/acompanhamentos/consultar-interacao-dia-dto';
import { PessoaAcompanhamentoEventoConsultaDto } from '../dtos/acompanhamentos/pessoa-acompanhamento-evento-dto';
import { PessoaAcompanhamentoEncerramentoDto } from '../dtos/acompanhamentos/pessoa-acompanhamento-encerramento-dto';
import { PessoaAcompanhamentoEventoEdicaoDto } from '../dtos/acompanhamentos/pessoa-acompanhamento-evento-edicao-dto';
import { PessoaAcompanhamentoAberturaDto } from '../dtos/acompanhamentos/pessoa-acompanhamento-abertura-dto';

@Injectable({
  providedIn: 'root'
})
export class AcompanhamentoService {

  constructor(private http: HttpClient, private url: UrlService) { }

  consultarAcompanhamento(id: number): Observable<PessoaAcompanhamentoConsultaDto> {
    return this.http.get<PessoaAcompanhamentoConsultaDto>(this.url.url(`acompanhamentos/${id}`));
  }

  consultarEvento(id: number): Observable<PessoaAcompanhamentoEventoConsultaDto> {
    return this.http.get<PessoaAcompanhamentoEventoConsultaDto>(this.url.url(`acompanhamentos/eventos/${id}`));
  }

  consultarResumoInteracaoDia(consulta: ConsultarInteracaoDiaDto): Observable<PessoaAcompanhamentoResumoInteracaoDiaDto> {
    let params = new HttpParams();
    params = params.append('ultimaInteracao', consulta.ultimaInteracao);
    params = params.append('data', consulta.data.toISOString());
    params = params.append('pessoaAcompanhamentoId', consulta.pessoaAcompanhamentoId);

    return this.http.get<PessoaAcompanhamentoResumoInteracaoDiaDto>(this.url.url(`acompanhamentos/interacoes/resumos`), { params: params });
  }

  listarEventos(id: number): Observable<LPessoaAcompanhamentoEventoDto[]> {
    return this.http.get<LPessoaAcompanhamentoEventoDto[]>(this.url.url(`acompanhamentos/${id}/eventos`));
  }
  
  listarMeusAcompanhementos(entrada: ListarAcompanhamentosDoProfissionalEntrada): Observable<any> {
    let filtro = new HttpParams();
    
    filtro = filtro.append('apenasAtivos', entrada.apenasAtivos);
    
    if (entrada.dataInicialRetorno) {
      filtro = filtro.append('dataInicialRetorno', entrada.dataInicialRetorno.toISOString());
    }
    
    if (entrada.dataFinalRetorno) {
      filtro = filtro.append('dataFinalRetorno', entrada.dataFinalRetorno.toISOString());
    }

    return this.http.get(this.url.url('acompanhamentos/meus'), { params: filtro });
  }

  listarAcompanhementos(entrada: ListarAcompanhamentosDaPessoaEntrada): Observable<any> {
    let filtro = new HttpParams();
    
    filtro = filtro.append('pessoaId', entrada.pessoaId)
                   .append('situacao', entrada.situacao);

    return this.http.get(this.url.url('acompanhamentos'), { params: filtro });
  }

  listarDoencas(pessoaId: number): Observable<AcompanhamentoCidOperacaoDto[]> {
    let params = new HttpParams();
    params = params.append('pessoaId', pessoaId);
    
    return this.http.get<AcompanhamentoCidOperacaoDto[]>(this.url.url(`acompanhamentos/doencas`), { params: params });
  }

  inserirAcompanhamento(dto: PessoaAcompanhamentoAberturaDto): Observable<any> {
    return this.http.post(this.url.url('acompanhamentos'), dto);
  }

  atualizarAcompanhamento(dto: PessoaAcompanhamentoAtualizacaoDto): Observable<any> {
    return this.http.patch(this.url.url('acompanhamentos'), dto);
  }

  encerrarAcompanhamento(dto: PessoaAcompanhamentoEncerramentoDto): Observable<any> {
    return this.http.patch(this.url.url('acompanhamentos/encerramentos'), dto);
  }

  editarEvento(dto: PessoaAcompanhamentoEventoEdicaoDto): Observable<any> {
    return this.http.patch(this.url.url('acompanhamentos/eventos'), dto);
  }

  excluirAcompanhamento(id: number): Observable<any> {
    return this.http.delete(this.url.url(`acompanhamentos/${id}`));
  }

  excluirEvento(id: number): Observable<any> {
    return this.http.delete(this.url.url(`acompanhamentos/eventos/${id}`));
  }
}
